<template>
  <div class="page" :class="{ active: isApp || miniprogram }">
    <common-title v-if="!isApp && !miniprogram" titleName="服务介绍" :zIndex="1000"></common-title>
    <div class="box">
      <tabs v-model="currentIndex" swipeable line-height="0">
        <tab v-for="(item, index) in benefits" :key="index">
          <template #title>
            <div class="benefits__nav">
              <img class="benefits__nav-img" :src="item.icon" alt="" />
              <span class="benefits__nav-title">{{ item.title }}</span>
            </div>
          </template>
          <div class="benefits__content" v-html="item.content"></div>
        </tab>
      </tabs>
      <div class="foot" @click="jumpPage" v-if="btnInfo">
        <div>{{ isApp ? btnInfo.appBtnName :miniprogram? btnInfo.miniBtnName:btnInfo.h5BtnName }}</div>
      </div>
      <van-overlay :show="show === 1" @click="show = 0">
        <div class="wrapper" v-if="btnInfo">
          <img class="img" :src="btnInfo.img" alt="" />
        </div>
      </van-overlay>
      <van-overlay :show="show === 2">
        <div class="app-content">
          <div>
            <img
              @click="show = 0"
              class="close"
              src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/vipProduct/close.png"
              alt=""
            />
            <h1>请前往应用商店下载“启航教育”APP 或扫描以下二维码下载</h1>
            <img
              class="main"
              src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/app_down.png"
              alt=""
            />
          </div>
        </div>
      </van-overlay>
    </div>
  </div>
</template>

<script>
import { Tabs, Tab } from 'vant';
import wx from 'weixin-js-sdk';
import { mapState } from 'vuex';
import { reqTypeList } from '@/api/home';
import { reqCourseExperience } from '@/api/vipProduct/index';
import { reqIsBuyProduct, reqCourseDetail } from '@/api/courseDetail/index';
import { getTaskApi } from '@/api/member/index';
import { reqSchemeUrl } from '@/api/openMini';
import { setBaseUrl } from '@/utils/tools';
import { reqSubOrder } from '@/api/pay/index';
import serviceList from './components/vipService';

export default {
  components: {
    Tabs,
    Tab,
  },
  data() {
    return {
      currentIndex: 0,
      activeCode: 0,
      isApp: this.$root.$data.isApp,
      miniprogram: this.$root.miniprogram,
      benefits: [],
      serviceList,
      btnInfo: null,
      buyInfo: [],
      show: 0,
    };
  },
  computed: {
    ...mapState(['userInfo']),
  },
  watch: {
    currentIndex(i) {
      this.setBtnInfo(i);
    },
  },
  mounted() {
    const { id } = this.$route.query;
    if (id) {
      // vip课程权益页面
      this.initVip();
    } else {
      // 书课学习权益页面
      this.initBook();
    }

    document.title = '服务介绍';
    window['iqhApp2jsBridge.triggerSC'] = {};
    setTimeout(() => {
      // 获取登录状态
      window['iqhApp2jsBridge.triggerSC'].getLogin = this.getLogin;
    }, 100);
  },
  methods: {
    async initVip() {
      const { id } = this.$route.query;
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true,
      });
      Promise.all([reqCourseExperience(id), reqTypeList('VIP_SERVICES')]).then((res) => {
        const [detail, dictionary] = res;
        const { customServicesList, learnService, experienceProductId } =
          detail?.data?.vipCourseExperienceConfigRespVO;
        const leanServiceArr = dictionary.data
          .filter((item) => learnService.split(',').some((subItem) => item.code === subItem))
          .map((item, i) => {
            const { remark, value, code } = item;
            const { title, icon } = JSON.parse(remark);
            return {
              title,
              icon,
              content: value,
              code,
            };
          });
        const benefits = [...leanServiceArr, ...customServicesList];
        const { active } = this.$route.query;
        this.benefits = benefits;
        this.currentIndex = Number(active);
        this.setBtnInfo(this.currentIndex);
        this.checkCourse(experienceProductId);
        this.$toast.clear();
      });
    },
    async initBook() {
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true,
      });
      const { active, courseId } = this.$route.query;
      const serviceList = this.$route.query.serviceList.split(',');
      const { data } = await reqTypeList('VIP_SERVICES');
      const learnServiceArr = data
        .filter((item) => serviceList.some((subItem) => Number(item.code) === Number(subItem)))
        .map((item) => {
          const { remark, value, code } = item;
          const { title, icon } = JSON.parse(remark);
          return {
            title,
            icon,
            content: value,
            code,
          };
        });
      this.benefits = [...learnServiceArr];
      this.currentIndex = Number(active);
      this.setBtnInfo(this.currentIndex);
      this.checkCourse(courseId);
      this.$toast.clear();
    },
    // 查开课状态
    async checkCourse(id) {
      const token =window.localStorage.getItem('accessToken')
      if(!token)return
      const { data } = await reqIsBuyProduct(id);
      this.buyInfo = data || [];
    },
    setBtnInfo(i) {
      const code = this.benefits.find((item, k) => k === i)?.code;
      this.btnInfo = this.serviceList[code];
    },
    jumpPage() {
      const { appJumpType, miniJumpType, miniPath,h5JumpType } = this.btnInfo;
      if (!this.userInfo?.id) {
        this.toLogin();
        return;
      }
      if (this.isApp) {
        this.openAppPage(appJumpType, miniPath);
      } else if (this.miniprogram) {
        this.openMiniPage(miniJumpType, miniPath);
      } else {
        this.openH5Page(h5JumpType, miniPath);
      }
    },
    openAppPage(type, miniPath) {
      //  type 1 app打开导学页 2 演示类  3 打开小程序
      console.log(type, miniPath);
      if (type === 1) {
        this.toLearn();
      } else if (type === 2) {
        this.show = 1;
      } else if (type === 3) {
        this.$sendToApp('goWechatProject', {
          userName: 'gh_5fb96ed24012',
          path: miniPath,
        });
      }else if (type === 4){
        this.$sendToApp('goToTkPage', 0, false);
      }
    },
    openMiniPage(type, miniPath) {
      //  type 1 下载app弹窗  2 打开导学页 3演示类 4 打开小程序
      console.log(type, miniPath);
      if (type === 1) {
        this.show = 2;
      } else if (type === 2) {
        this.toLearn();
      } else if (type === 3) {
        this.show = 1;
      } else if (type === 4) {
        wx.miniProgram.navigateTo({ url: `${miniPath}` });
      } else if (type === 5) {
        wx.miniProgram.switchTab({ url: `${miniPath}` });
      }
    },
    async openH5Page(type, miniPath) {
      console.log(type, miniPath,'openH5Page');
      // h5JumpType 1 下载app弹窗  2 打开导学页 3演示类 4 打开小程序  5 打开题库
      if (type === 1) {
        this.show = 2;
      } else if (type === 2) {
        this.toLearn();
      } else if (type === 3) {
        this.show = 1;
      } else if (type === 4) {
        let data = {
          appid: 'wxdb89cfa2bb60f779',
          path: miniPath,
          envVersion: !window.location.host.includes('mobile-test') ? 'release' : 'trial',
        };
        const res = await reqSchemeUrl(data);
        if (res?.code === 0) {
          window.location.href = res.data;
        }
      } else if (type === 5) {
        window.location.href = `${setBaseUrl('')}/question`;
      }
    },

    async toLearn() {
      const { active, courseId } = this.$route.query;
      if (courseId && !this.buyInfo?.length) {
        // 书课学习--免费领取该课程
        this.receiveCourse();
        return;
      }
      if (!this.buyInfo?.length) {
        this.$toast('未开通课程');
        return;
      }
      const { id } = this.buyInfo?.[0];
      const res = await this.entranceTask(id);
      if (res === 'unFinished') {
        if (this.miniprogram) {
          this.$toast('请前往app完成入学任务后，即可查看课程视频');
        } else if (this.isApp) {
          const { origin } = window.location;
          const url = `${origin}/ark/entranceTask?id=${id}`;
          this.$sendToApp('openNewWebView', { url }, false);
        } else {
          this.$router.push({
            path: '/entranceTask',
            query: {
              id,
            },
          });
        }
      } else if (res === 'finished') {
        if (this.$root.miniprogram) {
          wx.miniProgram.navigateTo({ url: `/myCourse/learningGuide/index?catalogId=${id}` });
        } else if (this.$root.$data.isApp) {
          this.$sendToApp('goDirectoryPage', { courseId: id }, false);
        } else {
          this.$router.push({
            path: '/learningGuide',
            query: {
              catalogId: id,
            },
          });
        }
      }
    },
    async entranceTask(id) {
      const { code, data } = await getTaskApi(id);
      if (code === 0) {
        const { agreementId, agreementDone, examId, examDone, examinationFlag, examinationDone } =
          data;
        this.examId = examId;
        if (
          (agreementId && !agreementDone) ||
          (examId && !examDone) ||
          (examinationFlag && !examinationDone)
        ) {
          return 'unFinished';
        }
        return 'finished';
      }
      return 'err';
    },
    // 去登录
    toLogin() {
      if (this.isApp) {
        this.$sendToApp('login', {}, true);
      } else if (this.miniprogram) {
        let url = window.location.href;
        const [domain, searchParams] = url.split('?');
        if (searchParams) {
          const params = searchParams.split('&');
          const paramsMap = new Map();
          params.forEach((item) => {
            const [key, value] = item.split('=');
            //  console.log('key', key, value);
            if (key) {
              paramsMap.set(key, value);
            }
          });
          const entries = paramsMap.entries();
          let query = '';
          const ExcludequeryArr = ['THIRD_SESSION', 'env'];
          // eslint-disable-next-line no-restricted-syntax
          for (const [key, value] of entries) {
            if (!ExcludequeryArr.includes(key)) query += `${key}=${value}&`;
          }
          url = `${domain}?${query}`;
          const redirctUrl = encodeURIComponent(
            `/subPackages/detailWebView/index?url=${encodeURIComponent(url)}`,
          );
          const path = `/subPackages/loginPage/loginPage?isHandle=1&isWebview=1&isCancelgoBack=1&redirctUrl=${redirctUrl}`;
          wx.miniProgram.redirectTo({
            url: path,
          });
        }
      } else {
        const param = { redirect: '/vipExperience', ...this.$route.query };
        this.$router.push({
          path: '/registrationLogin',
          query: param,
        });
      }
    },
    async getLoginAfter() {
      await this.$root.getUserInfo();
    },
    // app 登录回掉
    getLogin(APPSESSION) {
      const ua = navigator.userAgent.toLowerCase();
      const cookieToken = /ohos/.test(ua) ? APPSESSION.token : APPSESSION;
      if ((window?.navigator?.userAgent || '').includes('iqihang')) {
        window.localStorage.setItem('accessToken', cookieToken || '');
        this.getLoginAfter();
      }
    },
    // 查课程sku
    async getCourseSku(id) {
      const { data } = await reqCourseDetail(id);
      const { productSkuRespVOList } = data;
      return productSkuRespVOList?.[0]?.productSkuId;
    },
    // 免费领取
    async receiveCourse() {
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true,
      });
      const { courseId } = this.$route.query;
      const skuid = await this.getCourseSku(courseId);
      const subData = {
        // 订单提交请求对象
        channelMark: 5, // 下单渠道 ：5学员端下单
        products: [
          {
            productId: courseId,
            quantity: 1, // 产品数量
            type: 1, // 产品类别 1-主产品 2-增值产品 3-赠送产品
          },
        ],
        terminalMark: this.$global.terminalMark,
        orderReferer: '',
        // eslint-disable-next-line no-undef
        ip: sessionStorage.getItem('cityIp') || '',
        orderUrl: window.location.href,
      };
      subData.products[0].productSkuId = skuid;
      const { code, msg } = await reqSubOrder(subData);
      if (code === 0) {
        setTimeout(async() => {
        await this.checkCourse(courseId);
        this.$toast.clear();
        this.toLearn();

        }, 500);

      } else {
        this.$toast(msg);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  max-width: 750px;
  margin: 0 auto;
  padding-top: 95px;
}
.page.active {
  padding-top: 0;
}
.box {
  display: flex;
  flex-direction: column;
  width: 750px;
  height: 100vh;
  ::v-deep p {
    min-height: 40px !important;
  }
  ::v-deep p,
  ::v-deep span {
    color: #666 !important;
    font-weight: 400;
    font-size: 25px !important;
    font-style: normal;
    line-height: 40px !important;
    text-align: left;
  }
  ::v-deep .image-wrap {
    text-align: center !important;
  }
  ::v-deep img {
    display: inline-block;
    max-width: 612px !important;
    height: auto !important;
  }
}

.member__top {
  // height: 100px;
}

::v-deep .van-tabs__line {
  display: none;
}

.van-tabs {
  display: flex;
  flex: 1;
  flex-direction: column;
  height: 0;
}

::v-deep .van-tabs--line .van-tabs__wrap {
  height: 94px;
}

::v-deep .van-tabs--line .van-tabs__content {
  flex: 1;
  height: 0;
}

::v-deep .van-tabs--line .van-tabs__content .van-tab__pane {
  height: calc(100% - 22px);
  background: rgba(247, 248, 252, 1);
}

// ::v-deep .van-tabs__wrap--scrollable .van-tab {
// }

::v-deep .van-tab--active {
  .benefits__nav-title {
    color: #ff7f41 !important;
  }
}

::v-deep .van-tabs--line .van-tabs__content .benefits__content {
  height: 100%;
  margin-top: 11px;
  padding: 18px 18px 85px;
  overflow: auto;
  background-color: #fff;
}

.benefits__nav {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  &-img {
    width: 72px;
    height: 72px;
  }

  &-title {
    margin-top: 11px;
    color: #333;
    font-weight: 400;
    font-size: 22px;
    line-height: 31px;
  }
}
.foot {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 167px;
  padding-top: 43px;
  background: #fff;
  border-radius: 22px 22px 2px 2px;
  box-shadow: 0 -4 14px 0 rgba(0, 0, 0, 0.05);
  div {
    width: 678px;
    height: 80px;
    margin: 0 auto;
    color: #fff;
    font-weight: 500;
    font-size: 29px;
    line-height: 80px;
    text-align: center;
    background: #ff7f41;
    border-radius: 49px;
  }
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  img {
    width: 80%;
    border-radius: 14px;
  }
}
.app-content {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  > div {
    position: relative;
    width: 634px;
    height: 603px;
    text-align: center;
    background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/vipProduct/app-bg.png')
      no-repeat;
    background-color: #fff;
    background-size: 100%;
    border-radius: 36px;
    > h1 {
      padding: 85px 106px 36px 106px;
      color: #333;
      font-weight: 400;
      font-size: 25px;
      line-height: 40px;
      text-align: center;
    }
    .close {
      position: absolute;
      top: 40px;
      right: 40px;
      width: 29px;
    }
    .main {
      width: 344px;
      height: 344px;
    }
  }
}
</style>
